import { atomWithStorage } from 'jotai/utils';
import { ATOM_RESERVATION_SCHEDULE_REFETCH_KEY } from './atomConstants';

export const reservationScheduleRefetchAtom = atomWithStorage<boolean>(
    ATOM_RESERVATION_SCHEDULE_REFETCH_KEY,
    false,
    undefined,
    {
        getOnInit: true
    }
);
